import React from 'react';
import { BRAND } from '../../constants/brand';

const BrainIcon = ({ className = 'h-5 w-5', style = {}, alt = `${BRAND.product} icon` }) => (
  <img
    src={BRAND.iconSrc}
    alt={alt}
    className={`${className} object-cover`}
    style={{
      filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1))',
      imageRendering: 'crisp-edges',
      transform: 'scale(1.2)',
      ...style,
    }}
  />
);

export default BrainIcon;
